/*
 * Keep Smile.io's "Earn N Points when completing this purchase" in step with the
 * bundle offer the customer has selected (BundleX volume discount).
 *
 * Why this exists: products on this store have a single variant, so there is no
 * native variant change for Smile to react to — the amount the customer actually
 * pays comes from the offer widget instead, and Smile keeps showing the points
 * for the base price.
 *
 * Hooks used (taken from BundleX's own bundle: volume-discount.min.js):
 *   .js-bx-offer            each offer card, carries data-offer-key
 *   .bx-active              the selected offer
 *   .js-bx-offer-price      that offer's price
 *   .js-bx-total-price      the running total, when the layout renders one
 *
 * The points-per-currency rate is NOT hardcoded — it is derived on load from what
 * Smile itself rendered (basePoints / basePrice), so a change to the earning rule
 * in Smile is picked up automatically.
 *
 * Fully defensive: if the Smile block, the offer widget, or a price cannot be
 * read, the script does nothing and the original text is left untouched.
 */
(function () {
  'use strict';

  var CURRENCY = /[$€£¥]|USD|EUR|GBP/;
  var POINTS_LINE = /(\d[\d.,]*)\s*point/i;

  var smileBlock = document.querySelector('[id*="smile_points_on_product_page"]');
  if (!smileBlock) return;

  var pointsEl = null;
  var prefix = '';
  var suffix = '';
  var rate = null; // points per unit of currency

  /* ---- price reading ----------------------------------------------------- */

  function isStruck(el) {
    try {
      var s = window.getComputedStyle(el);
      return (s.textDecorationLine || s.textDecoration || '').indexOf('line-through') !== -1;
    } catch (e) {
      return false;
    }
  }

  function amountIn(el) {
    if (!el) return null;
    /* An offer price cell holds both the payable price and the crossed-out
       "was" price, so skip anything struck through. */
    var leaves = el.querySelectorAll('*');
    var nodes = leaves.length ? leaves : [el];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.children.length) continue;
      var t = (n.textContent || '').trim();
      if (!CURRENCY.test(t) || isStruck(n)) continue;
      var m = t.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
      if (m) return parseFloat(m[1]);
    }
    /* single node with no element children */
    var own = (el.textContent || '').trim();
    if (CURRENCY.test(own) && !isStruck(el)) {
      var m2 = own.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
      if (m2) return parseFloat(m2[1]);
    }
    return null;
  }

  function selectedPrice() {
    /* the widget's own total wins when the layout renders one */
    var total = amountIn(document.querySelector('.js-bx-total-price'));
    if (total !== null) return total;

    var active = document.querySelector('.js-bx-offer.bx-active');
    if (!active) return null;

    var priced = amountIn(active.querySelector('.js-bx-offer-price'));
    return priced !== null ? priced : amountIn(active);
  }

  /* ---- points text ------------------------------------------------------- */

  function locatePoints() {
    var els = smileBlock.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.children.length) continue;
      var t = el.textContent || '';
      var m = t.match(POINTS_LINE);
      if (!m) continue;
      var at = t.indexOf(m[1]);
      pointsEl = el;
      prefix = t.slice(0, at);
      suffix = t.slice(at + m[1].length);
      return parseFloat(m[1].replace(/,/g, ''));
    }
    return null;
  }

  function render(points) {
    if (!pointsEl) return;
    var next = prefix + points + suffix;
    /* only write when it actually changes, so the observer below can't loop */
    if (pointsEl.textContent !== next) pointsEl.textContent = next;
  }

  /* ---- wiring ------------------------------------------------------------ */

  function sync() {
    if (rate === null) return;
    var price = selectedPrice();
    if (price === null) return;
    render(Math.floor(price * rate));
  }

  var queued = false;
  function syncSoon() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }

  var tries = 0;
  (function calibrate() {
    var basePoints = locatePoints(); // Smile fills the number in after load
    var basePrice = selectedPrice(); // BundleX renders its offers after load

    if (basePoints !== null && basePrice) {
      rate = basePoints / basePrice;

      document.addEventListener('click', syncSoon, true);
      document.addEventListener('change', syncSoon, true);

      if (window.MutationObserver) {
        /* bx-active moves between offer cards, so watch class changes too */
        new MutationObserver(syncSoon).observe(document.body, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class']
        });
      }

      sync();
      return;
    }

    if (tries++ < 60) setTimeout(calibrate, 250); // ~15s for both apps to render
  })();
})();
